import React, { useState } from "react";
import { getComplianceByName, updateCompliance } from "../../../ruleService";
import { showDangerToast, showSuccessToast } from "../../../../validation/ToastContainer";
import { hasErrors } from "../../../../utils";
import { connect } from "react-redux";
import ComplianceNameField from "./ComplianceNameField";
import TargetTypeWizardModal from "../TargetTypeWizardModal";

function EditComplianceModal({ setShowModal, validationErrors, selectedCompliance }) {

    const [compliance, setCompliance] = useState(selectedCompliance);

    const onSaveClick = async () => {

        const serverCompliance = await getComplianceByName(compliance.name);
        let savedCompliance;

        if ((serverCompliance.error && serverCompliance.statusCode === 404) || serverCompliance.id === compliance.id) {
            savedCompliance = await updateCompliance(compliance);
        } else {
            showDangerToast(`Compliance with name '${compliance.name}' already exist`, "Save Compliance")
        }

        if (savedCompliance) {
            showSuccessToast("Compliance updated", "Save Compliance");
            setShowModal(false);
        }

    }

    return (
        <TargetTypeWizardModal
            title="Edit Compliance Wizard"
            subtitle="Update the selected compliance target type."
            onClose={() => setShowModal(false)}
            onSubmit={onSaveClick}
            submitLabel="Update"
            submitDisabled={hasErrors(validationErrors)}
            contentClassName="target-type-wizard-form__content--compact"
        >
            <ComplianceNameField compliance={compliance} setCompliance={setCompliance} />
        </TargetTypeWizardModal>
    );

}

function mapStateToProps(state) {
    return {
        validationErrors: state.validation
    }
}

export default connect(mapStateToProps)(EditComplianceModal);
